// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1IoEF","selects":"Documents_selects__kWD4a"};